export default "__VITE_ASSET__Df1RqgvB__"